import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.GOAL_ACTIONS_START_LOADING,
    success: AppConstants.GOAL_ACTIONS_SEARCH_SUCCESS,
    fail: AppConstants.GOAL_ACTIONS_SEARCH_FAIL
};

const GoalActions = {
    getListGoalActions(params, callback, events = defEvents) {
        events.before && dispatch({
            type: events.before
        });

        api.searchGoalActions({
            page: 1,
            count: 20,
            sort: 'id',
            order: 'desc',
            ...params
        })
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                dispatch({
                    type  : events.fail,
                    error : err
                });
            });
    },

    clear() {
        dispatch({
            type: AppConstants.GOAL_ACTIONS_CLEAR
        });
    }
};

export default GoalActions;
